import { post, get } from './service'
export const loginApi = data => {
  return post({
    url: "/login",
    data,
    silent: true
  })
}
export const logoutApi = data => {
  return post({
    url: "/logout",
    data
  })
}
// 当前登录用户信息（静默登录：小程序 web-view 携带 token 进入时换取完整用户信息）
export const getCurrentUserApi = data => {
  return get({
    url: "/user/current",
    data,
    silent: true
  })
}

// ---------- 滑动拼图验证 ----------
export const createSlideCaptchaApi = data => {
  return post({
    url: "/captcha/slide/create",
    data,
    silent: true
  })
}
export const verifySlideCaptchaApi = data => {
  return post({
    url: "/captcha/slide/verify",
    data,
    silent: true
  })
}

// ---------- 微信小程序扫码登录 ----------
export const createScanLoginApi = data => {
  return post({
    url: "/scan-login/create",
    data,
    silent: true
  })
}
export const getScanLoginStatusApi = data => {
  return get({
    url: "/scan-login/status",
    data,
    silent: true
  })
}
export const confirmScanLoginApi = data => {
  return post({
    url: "/scan-login/confirm",
    data,
    silent: true
  })
}
export const getUserListApi = data => {
  return get({
    url: "/user/listAll",
    data
  })
}
export const getUserListAllApi = data => {
  return get({
    url: "/user/listAll",
    data
  })
}
export const getUserListByPageApi = data => {
  return get({
    url: "/user/listByPage",
    data
  })
}
export const addUserApi = data => {
  return post({
    url: "/user/save",
    data
  })
}
export const deleteUserByIdApi = data => {
  return get({
    url: "/user/delete",
    data
  })
}
export const updateUserApi = data => {
  return post({
    url: "/user/update",
    data
  })
}

export const getProjectListApi = data => {
  return get({
    url: "/project",
    data
  })
}
export const selectCountDataApi = data => {
  return get({
    url: "/project/selectcountData",
    data
  })
}
export const unfinishedProjectlistsApi = data => {
  return get({
    url: "/project/unfinished",
    data
  })
}
export const queryProjectListApi = data => {
  return post({
    url: "/project/query",
    data
  })
}
export const addProjectApi = data => {
  return post({
    url: "/project/create",
    data
  })
}
export const updateProjectApi = data => {
  return post({
    url: "/project/update",
    data
  })
}


export const deleteProjectByIdApi = data => {
  return get({
    url: "/project/delete",
    data
  })
}
export const getRolesListApi = data => {
  return post({
    url: "/role/listAll",
    data
  })
}
export const selectByTypeCountApi = data => {
  return get({
    url: "/project/selectByTypeCount",
    data
  })
}
export const selectAllCountApi = data => {
  return get({
    url: "/project/allCount",
    data
  })
}

export const excelImportProjectApi = data => {
  return post({
    url: "/project/excelImport",
    data,
    headers: { "Content-Type": "multipart/form-data" },
    timeout: 60000
  })
}




export const addRoleApi = data => {
  return post({
    url: "/role/save",
    data
  })
}
export const deleteRoleApi = data => {
  return get({
    url: "/role/delete",
    data
  })
}
export const getDepartmentsListApi = data => {
  return post({
    url: "/department/listAll",
    data
  })
}
export const addDepartmentApi = data => {
  return post({
    url: "/department/save",
    data
  })
}
export const updateDepartmentApi = data => {
  return post({
    url: "/department/update",
    data
  })
}
export const deletDepartmentApi = data => {
  return get({
    url: "/department/delete",
    data
  })
}
export const getDevProjectListApi = data => {
  return get({
    url: "/dev-project/listAll",
    data
  })
}
export const importDevProjectApi = data => {
  return post({
    url: "/dev-project/import",
    data,
    headers: { "Content-Type": "multipart/form-data" },
    timeout: 60000
  })
}
export const addDevProInfoApi = data => {
  return post({
    url: "/dev-project-info/create",
    data
  })
}
export const selectCountDevDataApi = data => {
  return get({
    url: "/dev-project/selectByUserCount",
    data
  })
}
export const selectDevByTypeCountApi = data => {
  return get({
    url: "/dev-project/selectByTypeCount",
    data
  })
}
export const unfinishedDevProjectlistsApi = data => {
  return get({
    url: "/dev-project/unfinished",
    data
  })
}
export const selectDevAllCountApi = data => {
  return get({
    url: "/dev-project/allCount",
    data
  })
}
export const getDPInfoListByidApi = data => {
  return get({
    url: "/dev-project-info/queryByproId",
    data
  })
}
export const getProgressListApi = data => {
  return post({
    url: "/dev-project-progress/listAll",
    data
  })
}

export const getWorkRecordListApi = data => {
  return post({
    url: "/work-record/list",
    data
  })
}
export const getWorkRecordListAllApi = data => {
  return get({
    url: "/work-record/listAll",
    data
  })
}
export const getWorkRecordListByDateApi = data => {
  return post({
    url: "/work-record/listByDate",
    data
  })
}
export const updateWorkRecordApi = data => {
  return post({
    url: "/work-record/update",
    data
  })
}
export const createWorkRecordApi = data => {
  return post({
    url: "/work-record/create",
    data
  })
}
export const getApprovalListApi = data => {
  return post({
    url: "/approval/list",
    data
  })
}
export const getApprovalListAllApi = data => {
  return get({
    url: "/approval/listAll",
    data
  })
}
export const queryApprovalListApi = data => {
  return post({
    url: "/approval/query",
    data
  })
}
export const createApprovalApi = data => {
  return post({
    url: "/approval/create",
    data
  })
}
export const updateApprovalApi = data => {
  return post({
    url: "/approval/update",
    data
  })
}
export const importApprovalApi = data => {
  return post({
    url: "/approval/import",
    data,
    headers: { "Content-Type": "multipart/form-data" },
    timeout: 60000
  })
}
export const getPlanInfoListApi = data => {
  return post({
    url: "/progress/listAll",
    data
  })
}
export const getpriorityListApi = data => {
  return post({
    url: "/priority/listAll",
    data
  })
}
export const uploadApi = data => {
  return post({
    url: "/upload/up",
    data
  })
}

export const getMarkdownDocListApi = data => {
  return get({
    url: "/markdown-doc/listAll",
    data
  })
}
export const getMarkdownDocDetailApi = data => {
  return get({
    url: "/markdown-doc/detail",
    data
  })
}
export const saveMarkdownDocApi = data => {
  return post({
    url: "/markdown-doc/save",
    data
  })
}
export const deleteMarkdownDocApi = data => {
  return get({
    url: "/markdown-doc/delete",
    data
  })
}
export const copyMarkdownDocApi = data => {
  return post({
    url: "/markdown-doc/copy",
    data
  })
}
export const updateMarkdownDocMetaApi = data => {
  return post({
    url: "/markdown-doc/updateMeta",
    data
  })
}
export const getMarkdownDocCategoryListApi = data => {
  return get({
    url: "/markdown-doc/categoryList",
    data
  })
}
export const getMarkdownVersionListApi = data => {
  return get({
    url: "/markdown-doc-version/list",
    data
  })
}
export const getMarkdownVersionDetailApi = data => {
  return get({
    url: "/markdown-doc-version/detail",
    data
  })
}
export const restoreMarkdownVersionApi = data => {
  return post({
    url: "/markdown-doc-version/restore",
    data
  })
}

// ---------- 知识库文档（文档汇总独立存储，与周报 markdown_doc 分离） ----------
export const getKnowledgeDocListApi = data => {
  return get({
    url: "/knowledge-doc/listAll",
    data
  })
}
export const getKnowledgeDocDetailApi = data => {
  return get({
    url: "/knowledge-doc/detail",
    data
  })
}
export const saveKnowledgeDocApi = data => {
  return post({
    url: "/knowledge-doc/save",
    data
  })
}
export const deleteKnowledgeDocApi = data => {
  return get({
    url: "/knowledge-doc/delete",
    data
  })
}
export const copyKnowledgeDocApi = data => {
  return post({
    url: "/knowledge-doc/copy",
    data
  })
}
export const updateKnowledgeDocMetaApi = data => {
  return post({
    url: "/knowledge-doc/updateMeta",
    data
  })
}
export const getKnowledgeDocCategoryListApi = data => {
  return get({
    url: "/knowledge-doc/categoryList",
    data
  })
}
export const getKnowledgeVersionListApi = data => {
  return get({
    url: "/knowledge-doc-version/list",
    data
  })
}
export const getKnowledgeVersionDetailApi = data => {
  return get({
    url: "/knowledge-doc-version/detail",
    data
  })
}
export const restoreKnowledgeVersionApi = data => {
  return post({
    url: "/knowledge-doc-version/restore",
    data
  })
}
export const uploadFileApi = data => {
  return post({
    url: "/upload/up",
    data,
    headers: { "Content-Type": "multipart/form-data" }
  })
}

// ---------- 在线文档（富文本编辑器 wangeditor，知识库） ----------
export const getRichDocListApi = data => {
  return get({
    url: "/rich-doc/listAll",
    data
  })
}
export const getRichDocDetailApi = (data, options = {}) => {
  return get({
    url: "/rich-doc/detail",
    data,
    ...options
  })
}
export const saveRichDocApi = (data, options = {}) => {
  return post({
    url: "/rich-doc/save",
    data,
    ...options
  })
}
export const uploadImageFromUrlApi = data => {
  return post({
    url: "/upload/from-url",
    data,
    timeout: 20000
  })
}
export const importRichDocApi = data => {
  return post({
    url: "/rich-doc/import",
    data,
    headers: { "Content-Type": "multipart/form-data" },
    timeout: 60000,
    rawFail: true
  })
}
export const uploadPdfApi = data => {
  return post({
    url: "/rich-doc/uploadPdf",
    data,
    headers: { "Content-Type": "multipart/form-data" },
    timeout: 60000
  })
}
export const deleteRichDocApi = data => {
  return get({
    url: "/rich-doc/delete",
    data
  })
}
export const copyRichDocApi = data => {
  return post({
    url: "/rich-doc/copy",
    data
  })
}
export const updateRichDocMetaApi = data => {
  return post({
    url: "/rich-doc/updateMeta",
    data
  })
}
export const getRichDocCategoryListApi = data => {
  return get({
    url: "/rich-doc/categoryList",
    data
  })
}
export const getRichVersionListApi = data => {
  return get({
    url: "/rich-doc-version/list",
    data
  })
}
export const getRichVersionDetailApi = data => {
  return get({
    url: "/rich-doc-version/detail",
    data
  })
}
export const restoreRichVersionApi = data => {
  return post({
    url: "/rich-doc-version/restore",
    data
  })
}

// ---------- 在线表格（x-spreadsheet，知识库） ----------
export const getSheetDocListApi = data => {
  return get({
    url: "/sheet-doc/listAll",
    data
  })
}
export const getSheetDocDetailApi = data => {
  return get({
    url: "/sheet-doc/detail",
    data
  })
}
export const createSheetDocApi = data => {
  return post({
    url: "/sheet-doc/create",
    data
  })
}
export const saveSheetDocApi = data => {
  return post({
    url: "/sheet-doc/save",
    data
  })
}
export const deleteSheetDocApi = data => {
  return get({
    url: "/sheet-doc/delete",
    data
  })
}
export const updateSheetDocMetaApi = data => {
  return post({
    url: "/sheet-doc/updateMeta",
    data
  })
}
export const getSheetVersionListApi = data => {
  return get({
    url: "/sheet-doc-version/list",
    data
  })
}
export const getSheetVersionDetailApi = data => {
  return get({
    url: "/sheet-doc-version/detail",
    data
  })
}
export const restoreSheetVersionApi = data => {
  return post({
    url: "/sheet-doc-version/restore",
    data
  })
}

// ---------- 在线流程图（Draw.io 官方源码本地静态部署，知识库） ----------
export const getDrawioDocListApi = data => get({ url: "/drawio-doc/listAll", data })
export const getDrawioDocDetailApi = data => get({ url: "/drawio-doc/detail", data })
export const createDrawioDocApi = data => post({ url: "/drawio-doc/create", data })
export const saveDrawioDocApi = data => post({ url: "/drawio-doc/save", data })
export const updateDrawioDocMetaApi = data => post({ url: "/drawio-doc/updateMeta", data })
export const deleteDrawioDocApi = data => get({ url: "/drawio-doc/delete", data })
export const getDrawioVersionListApi = data => get({ url: "/drawio-doc-version/list", data })
export const getDrawioVersionDetailApi = data => get({ url: "/drawio-doc-version/detail", data })
export const restoreDrawioVersionApi = data => post({ url: "/drawio-doc-version/restore", data })

// ---------- 在线内容统一树与分组 ----------
export const getDocumentTreeListApi = data => get({ url: "/rich-doc/treeList", data })
export const createDocumentFolderApi = data => post({ url: "/rich-doc/folder", data })
export const updateDocumentTreeMetaApi = data => post({ url: "/rich-doc/treeMeta", data })
export const deleteDocumentTreeNodeApi = data => get({ url: "/rich-doc/treeDelete", data })

// ---------- 服务器日志（仅管理员可查询/清空） ----------
export const getWebErrorLogListApi = data => get({ url: "/web-log/list", data })
export const clearWebErrorLogApi = data => post({ url: "/web-log/clear", data })
